import { Controller } from "react-hook-form";
import { FieldProps } from "modules/record/record-producer/types/record-producer-types";
import { BaseField } from "./BaseField";
import { BooleanFieldInput } from "modules/record/shared/fields/BooleanFieldInput";
import { buildRequiredRule, getRequiredFieldMessage } from "../../services/recordProducerValidation";
import { normalizeBooleanValue } from "modules/record/shared/fields/booleanValue";
import { getFieldHelperText } from "../../services/fieldHelperText";

export const BooleanFieldComponent = ({ column, control, baseFieldProps, runtimeProps }: FieldProps) => {
    return (
        <BaseField column={column} required={runtimeProps?.required} hidden={runtimeProps?.hidden} {...baseFieldProps}>
            <Controller
                name={column.name}
                control={control}
                defaultValue={normalizeBooleanValue(column.default_value)}
                rules={{ required: buildRequiredRule(runtimeProps?.required ?? column.is_mandatory, getRequiredFieldMessage(column)) }}
                render={({ field, fieldState }) => (
                    <BooleanFieldInput
                        value={field.value}
                        onChange={field.onChange}
                        disabled={runtimeProps?.readonly}
                        error={!!fieldState.error}
                        helperText={getFieldHelperText(fieldState, runtimeProps)}
                    />
                )}
            />
        </BaseField>
    );
};
